<script>
export default {
  name: 'Timeline',
  methods: {
    getTotalTimelineHeight () {
      let hoursTopData = this.reservationsData[this.firstWorkerID].hours_top;
      let endHour = hoursTopData.slice().pop();

      if (endHour) {
        return endHour.top_px + 50;
      }

      return 0;
    },
    timelineServiceColor (data) {
      if (!this.servicesEnabled) {
        return '#2696E9';
      }

      if (data.inquiry.service && data.inquiry.service.color) {
        return data.inquiry.service.color;
      }

      return '#2696E9';
    },
    timelineServiceReversedColor (data) {
      if (!data.inquiry.service || !data.inquiry.service.color) {
        return '#222';
      }

      let r;
      let g;
      let b;

      if (data.inquiry.service.color.indexOf('rgb') > -1) {
        let colorRgba = data.inquiry.service.color;
        colorRgba = colorRgba.replace('rgba(', '').replace('rgb(', '').replace(')', '');
        colorRgba = colorRgba.split(',').map(n => parseInt(n.trim(), 10));
        r = colorRgba[0];
        g = colorRgba[1];
        b = colorRgba[2];
      } else {
        let hex = data.inquiry.service.color.slice(1);

        if (hex.length === 3) {
          hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
        }

        r = parseInt(hex.slice(0, 2), 16);
        g = parseInt(hex.slice(2, 4), 16);
        b = parseInt(hex.slice(4, 6), 16);
      }

      return (r * 0.299 + g * 0.587 + b * 0.114) > 186 ? '#222' : '#fff';
    },
    timelineInquiryTime (data) {
      let start = data.inquiry.start_at;
      let end = data.inquiry.end_at;

      if (start && end) {
        start = start.split(' ');
        end = end.split(' ');

        if (start[1] && end[1]) {
          return start[1] + ' - ' + end[1];
        }
      }

      return '';
    },
    timelineInquiryName (data) {
      return data.inquiry.name;
    },
    timelineInquiryTimeDiff (data) {
      let height = parseFloat(data.height);
      let width = parseFloat(data.width);

      if (width > 50 && height >= 2.5) {
        return 2;
      }

      if (width > 50 && height < 2.5) {
        return 1;
      }

      if (width <= 50 && height >= 5) {
        return 2;
      }

      if (width <= 50 && height < 5) {
        return 1;
      }

      return 1;
    },
    timelineGetSeparatorTop (index, subindex) {
      let hoursTopData = this.reservationsData[this.firstWorkerID].hours_top;
      let startHour = hoursTopData[index];
      let endHour = hoursTopData[index + 1];

      if (endHour) {
        let diff = (endHour.top_px - startHour.top_px);
        let separatorsCount = this.timelineCountSeparators(startHour, endHour);
        if (subindex > separatorsCount) {
          return 0;
        }

        return ((diff / (separatorsCount + 1)) * subindex) + startHour.top_px;
      }

      return 0;
    },
    timelineCountSeparators (startHour, endHour) {
      let start = startHour.hour.split(':').map(n => parseInt(n, 10));
      let end = endHour.hour.split(':').map(n => parseInt(n, 10));
      let startTimestamp = +new Date(2000, 0, 1, start[0], start[1], 0, 0);
      let endTimestamp = +new Date(2000, 0, 1, end[0], end[1], 0, 0);

      if (endTimestamp - startTimestamp >= 3600000) {
        return 3;
      }

      if (endTimestamp - startTimestamp > 2700000) {
        return 3;
      }

      if (endTimestamp - startTimestamp > 1800000) {
        return 2;
      }

      if (endTimestamp - startTimestamp > 900000) {
        return 1;
      }

      return 0;
    },
    helperItemHeight () {
      let pxAs5min = this.reservationsData[this.firstWorkerID].px_to_15_min / 3;
      let baseUnit = this.$store.state.config.company.time_increaser;
      let baseHeight = (baseUnit / 5) * pxAs5min;

      if (baseHeight <= 0) {
        baseHeight = pxAs5min;
      }

      return baseHeight;
    },
    calculateHourOnMouseMove (event, workerID) {
      let pxAs5min = this.reservationsData[this.firstWorkerID].px_to_15_min / 3;
      let startHour = this.reservationsData[this.firstWorkerID].hours_top[0].hour.split(':').map(n => parseInt(n, 10));
      let baseUnit = this.$store.state.config.company.time_increaser;
      let baseDistance = (baseUnit / 5) * pxAs5min;

      if (baseDistance <= 0) {
        baseDistance = pxAs5min;
      }

      this.hoveredTimelineHelperTop = Math.floor(event.layerY / baseDistance) * baseDistance;
      let clickedMinutes = Math.ceil(Number(this.hoveredTimelineHelperTop / pxAs5min).toFixed(2)) * 5;
      let clickedHours = Math.floor(clickedMinutes / 60);
      let restClickedMinutes = clickedMinutes % 60;
      startHour[0] += clickedHours;
      startHour[1] += restClickedMinutes;

      if (startHour[1] >= 60) {
        if (startHour[1] === 60) {
          startHour[0] += 1;
        } else {
          startHour[0] += 1;
          startHour[1] -= 60;
        }
      }

      this.timelineSelectedHour = startHour.map(n => n < 10 ? '0' + n : n).join(':');
    },
    clickedTimeSlot (workerIndex) {
      let startHour = this.reservationsData[0].hours_top[0].hour.split(':').map(n => parseInt(n, 10));
      let pxAs5Min = this.reservationsData[0].px_to_15_min / 3;
      let clickedMinutes = Math.ceil(Number(this.hoveredTimelineHelperTop / pxAs5Min).toFixed(2)) * 5;
      let clickedHours = Math.floor(clickedMinutes / 60);
      let restClickedMinutes = clickedMinutes % 60;
      startHour[0] += clickedHours;
      startHour[1] += restClickedMinutes;

      if (startHour[1] >= 60) {
        if (startHour[1] === 60) {
          startHour[0] += 1;
        } else {
          startHour[0] += 1;
          startHour[1] -= 60;
        }
      }

      startHour = startHour.map(n => n < 10 ? '0' + n : n).join(':');

      if (parseInt(startHour.split(':').join(''), 10) >= 2400) {
        return;
      }

      let workerID = parseInt(this.filteredReservationsData[workerIndex].worker.id, 10);
      let today = new Date();
      let dateParam = [today.getFullYear(), today.getMonth() + 1, today.getDate()].map(n => n < 10 ? '0' + n : n).join('-');

      if (this.currentYear) {
        dateParam = [this.currentYear, this.currentMonth, this.$parent.currentDay].map(n => n < 10 ? '0' + n : n).join('-');
      }

      let serviceParam = '';

      if (this.filters && this.filters.service && this.filters.service.indexOf('s') > -1) {
        serviceParam = this.filters.service.replace('s', '');
      }

      this.$bus.$emit('confirm-display', {
        title: this.$t('common.ui.addingReservation'),
        desc: this.$t('calendar.other.youWantToAddReservation', { date: dateParam, time: startHour }),
        cancelLabel: this.$t('common.ui.cancel'),
        cancelClick: () => false,
        okLabel: this.$t('common.ui.addReservation'),
        okClick: () => this.$router.push('/reservation/new/date/' + dateParam + '/' + startHour + '/' + workerID + '/' + serviceParam),
        isDanger: false
      });
    }
  }
}
</script>

<style lang="scss">
@import '../../assets/scss/variables.scss';

.timeline {
  &-content {
    position: relative;

    .timeline-content-helper {
      background: $color-link;
      border-radius: 5px;
      left: 0;
      opacity: .5;
      pointer-events: none;
      position: absolute;
      width: 100%;
      z-index: 10;

      &[data-selected-hour="24:00"],
      &[data-selected-hour="24:05"],
      &[data-selected-hour="24:10"],
      &[data-selected-hour="24:15"],
      &[data-selected-hour="24:20"],
      &[data-selected-hour="24:25"],
      &[data-selected-hour="24:30"] {
        display: none;
      }

      &:before {
        content: attr(data-selected-hour);
        color: #fff;
        font-size: 11px;
        font-weight: bold;
        left: 10px;
        line-height: 1;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
      }

      &:after {
        background: #fff;
        box-shadow: 0 0 5px darken($color-link, 25%);
        border-radius: 50%;
        color: $color-link;
        content: "+";
        font-size: 24px;
        font-weight: bold;
        height: 24px;
        left: 50%;
        line-height: 24px;
        text-align: center;
        transform: translateX(-50%) translateY(-50%);
        pointer-events: none;
        position: absolute;
        top: 50%;
        width: 24px;
        z-index: 11;
      }
    }

    &-inquiry {
      align-items: center;
      border: 1px solid $color-bg-lightest;
      border-radius: $border-radius-small;
      cursor: pointer;
      display: flex;
      overflow: hidden;
      padding: .5rem;
      position: absolute;

      &:hover {
        opacity: .75;
      }

      &-details {
        align-items: center;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        width: 100%;
      }

      &-time,
      &-name,
      &-people {
        color: inherit;
        display: block;
        font-size: 12px;
        line-height: 1.2;
        text-align: center;
        width: 100%;
      }

      &-time {
        font-weight: 700;
      }
    }

    &-not-working {
      background: repeating-linear-gradient(
        45deg,
        rgba(0, 0, 0, .08),
        rgba(0, 0, 0, .08) 20px,
        transparent 20px,
        transparent 40px
      );
      left: -25px;
      position: absolute;
      pointer-events: none;
      right: -25px;

      &.timeline-content-not-working-whole-day {
        background: repeating-linear-gradient(
          45deg,
          rgba(237, 28, 35, .1),
          rgba(237, 28, 35, .1) 20px,
          transparent 20px,
          transparent 40px
        );
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mixins/Timeline.vue